module.exports = "/_next/static/images/slide-3-7a23892a043e98be19995f7a8d30ae58.png";